// conditionalNode.js - Routes data based on conditions

import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const ConditionalNode = ({ id, data }) => {
  const [condition, setCondition] = useState(data?.condition || 'if');

  const handles = [
    { id: 'input', type: 'target', position: Position.Left },
    { id: 'true', type: 'source', position: Position.Right, top: 25 },
    { id: 'false', type: 'source', position: Position.Right, top: 75 }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      title="Conditional"
      description="Route based on condition"
      handleConfig={handles}
      width={200}
      height={160}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '12px' }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
          <span style={{ fontWeight: '500', color: '#555' }}>Logic:</span>
          <select 
            value={condition}
            onChange={(e) => setCondition(e.target.value)}
            style={{
              padding: '4px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px'
            }}
          >
            <option value="if">If</option>
            <option value="unless">Unless</option>
            <option value="switch">Switch</option>
          </select>
        </label>
      </div>
    </BaseNode>
  );
};
